import React from "react"
import PropTypes from "prop-types"
import { graphql, Link } from "gatsby"
import theme from "theme"

const TrackPill = ({
  name,
  slug,
  colorScheme: { textColor, backgroundColor },
  tabIndex,
  className,
}) => (
  <Link
    to={slug.current}
    css={{
      ...theme.hxxs,
      textDecoration: "none",
      border: `2px solid ${theme.black}`,
      borderRadius: 30,
      color: textColor.color.hex,
      background: backgroundColor.color.hex,
      padding: "6px 16px",
      ":hover": {
        color: backgroundColor.color.hex,
        background: textColor.color.hex,
      },
    }}
    className={className}
    tabIndex={tabIndex}
  >
    {name}
  </Link>
)

export default TrackPill

TrackPill.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.shape({
    current: PropTypes.string.isRequired,
  }).isRequired,
  colorScheme: PropTypes.shape({
    textColor: PropTypes.shape({
      color: PropTypes.shape({
        hex: PropTypes.string.isRequired,
      }),
    }),
    backgroundColor: PropTypes.shape({
      color: PropTypes.shape({
        hex: PropTypes.string.isRequired,
      }),
    }),
  }),
  className: PropTypes.string,
  tabIndex: PropTypes.string,
}

export const query = graphql`
  fragment TrackPill on SanityConfigTrack {
    name
    slug {
      current
    }
    colorScheme {
      textColor {
        color {
          hex
        }
      }
      backgroundColor {
        color {
          hex
        }
      }
    }
  }
`
